// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L61ugwTGELX392LdfY9t{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.L61ugwTGELX392LdfY9t .j9AGFbpTESdgcXmO4x7H{width:100%;height:100%;max-width:1024px;display:flex;flex-direction:column;align-items:center;gap:2em}.L61ugwTGELX392LdfY9t .j9AGFbpTESdgcXmO4x7H .vV28JAYrLIi1okfaY2OQ{flex:1;width:100%}.L61ugwTGELX392LdfY9t .j9AGFbpTESdgcXmO4x7H .a0VfPgFtY5_UnzkQnTtd{flex:0 0;vertical-align:middle;width:fit-content}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `L61ugwTGELX392LdfY9t`,
	"rightComponent": `j9AGFbpTESdgcXmO4x7H`,
	"slide": `vV28JAYrLIi1okfaY2OQ`,
	"switch": `a0VfPgFtY5_UnzkQnTtd`
};
export default ___CSS_LOADER_EXPORT___;
